import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

// Skeleton designed to mirror the real TicketListItem card so the
// reveal feels like content fading in, not a layout swap. SKILL §3
// (progressive-loading): skeletons should resemble actual content.
const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    padding: "12px 14px",
    margin: "6px 4px",
    borderRadius: 12,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(30, 41, 59, 0.6)"
        : "#ffffff",
    border:
      theme.palette.type === "dark"
        ? "1px solid rgba(255,255,255,0.06)"
        : "1px solid #e2e8f0",
  },
  body: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  topRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
  },
  badgesRow: {
    display: "flex",
    gap: 6,
    marginTop: 2,
  },
}));

const TicketCardSkeleton = () => {
  const classes = useStyles();
  return (
    <div className={classes.card}>
      <Skeleton animation="wave" variant="circle" width={40} height={40} />
      <div className={classes.body}>
        <div className={classes.topRow}>
          <Skeleton animation="wave" height={14} width="55%" />
          <Skeleton animation="wave" height={10} width={36} />
        </div>
        <Skeleton animation="wave" height={12} width="80%" />
        <div className={classes.badgesRow}>
          <Skeleton animation="wave" height={16} width={68} style={{ borderRadius: 8 }} />
          <Skeleton animation="wave" height={16} width={50} style={{ borderRadius: 8 }} />
        </div>
      </div>
    </div>
  );
};

const TicketsSkeleton = () => (
  <>
    <TicketCardSkeleton />
    <TicketCardSkeleton />
    <TicketCardSkeleton />
    <TicketCardSkeleton />
    <TicketCardSkeleton />
  </>
);

export default TicketsSkeleton;
